module.exports = __webpack_public_path__ + "static/5-fa06466ec9dbc28dbbdd22725c9f30c5.webp";